import {
  AREA_CATALOG,
  areaOfService,
  areaOfSpecialist,
  meetingArea,
  type AreaDefinition,
  type AreaKey,
} from '@secretario/shared';

/**
 * Arte da equipe: só objetos 3D, sem rosto. O único personagem do app é o
 * Secretário da pessoa; área e habilidade aparecem como objeto.
 */
/** Objeto 3D de uma habilidade (ou do Meu negócio). */
export function skillObject(key: string): string {
  return `/habilidades/${key}.webp`;
}

/** Objeto que representa cada área (cartões, Reunião, serviços e entregas). */
const AREA_OBJECT: Record<AreaKey, string> = {
  dinheiro: 'contas',
  rotina: 'bom_dia',
  informacao: 'noticias',
  trabalho: 'negocio',
};

export function areaObject(area: AreaDefinition | AreaKey | undefined): string {
  const key = typeof area === 'string' ? area : area?.key;
  return skillObject(AREA_OBJECT[key ?? 'rotina'] ?? AREA_OBJECT.rotina);
}

/** Área que cuida de um serviço pronto. */
export function serviceArtist(serviceKey: string): AreaDefinition {
  return areaOfService(serviceKey) ?? AREA_CATALOG[1]!;
}

/** Objeto de um serviço pronto ou de uma entrega: o da área que cuida dele. */
export function serviceObject(serviceKey: string): string {
  return areaObject(serviceArtist(serviceKey));
}

/** Área de uma habilidade (para as telas das habilidades). */
export function specialistArtist(specialistKey: string): AreaDefinition | undefined {
  return areaOfSpecialist(specialistKey);
}

/** Quem fala na Reunião (aceita a chave antiga do especialista). */
export function meetingSpeaker(speaker: string | null | undefined): AreaDefinition | undefined {
  return meetingArea(speaker);
}

/** Cor de destaque de cada área (bordas e nomes na Reunião). */
export const AREA_ACCENT: Record<AreaKey, string> = {
  dinheiro: '#2f9e74',
  rotina: '#e15f2e',
  informacao: '#8a63d2',
  trabalho: '#c8912e',
};

export const AREA_TONE: Record<AreaDefinition['tone'], string> = {
  mint: 'var(--mint)',
  peach: 'var(--peach)',
  lilac: 'var(--lilac)',
  toon: 'var(--toon)',
};
